import React from 'react';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { getTimeDurationFromSeconds } from '../../utils/DataFormatterUtils';
import { Divider } from 'antd';

const SimpleLineItemsDisplay = ({ invoice, lineItemFieldName, currency }) => {
	return nullSafeGetOrElse(lineItemFieldName, invoice, []).map((mli, idx) => (
		<div
			key={`${lineItemFieldName}-${idx}`}
			className="sectionHeaderWrapper2"
			style={{
				marginBottom: idx === nullSafeGetOrElse(lineItemFieldName, invoice, []).length - 1 ? 16 : 8,
			}}
		>
			<span className="lineItemDetailText">{mli.description}</span>
			<span className="lineItemDetailText">{currency.format(parseFloat(mli.amount))}</span>
		</div>
	));
};

export default function InvoiceDetailsDisplay({ invoice, currency }) {
	return (
		<>
			<div className="sectionHeaderWrapper" style={{ marginBottom: 8 }}>
				<span className="sectionHeaderText">Labor</span>
				<span className="sectionHeaderText2">{currency.format(invoice.laborTotalBeforeTax)}</span>
			</div>
			{nullSafeGetOrElse('laborLineItems', invoice, []).map((lli, idx) => (
				<div
					key={`laborLineItems-${idx}`}
					className="sectionHeaderWrapper2"
					style={{
						marginBottom:
							idx === nullSafeGetOrElse('laborLineItems', invoice, []).length - 1 ? 16 : 8,
					}}
				>
					<span className="lineItemDetailText">
						{lli.numberOfTech} {lli.roleType} * {getTimeDurationFromSeconds(lli.seconds)} @{' '}
						{currency.format(parseFloat(lli.hourlyRate))} / hour
					</span>
					<span className="lineItemDetailText">{currency.format(parseFloat(lli.amount))}</span>
				</div>
			))}
			<Divider />
			<div className="sectionHeaderWrapper" style={{ marginBottom: 8 }}>
				<span className="sectionHeaderText">Materials</span>
				<span className="sectionHeaderText2">
					{currency.format(invoice.materialTotalBeforeTax)}
				</span>
			</div>
			{nullSafeGetOrElse('materialLineItems', invoice, []).map((mli, idx) => (
				<div
					key={`materialLi-${idx}`}
					className="sectionHeaderWrapper2"
					style={{
						marginBottom:
							idx === nullSafeGetOrElse('laborLineItems', invoice, []).length - 1 ? 16 : 8,
					}}
				>
					<span className="lineItemDetailText">
						{mli.quantity} {mli.unitType} of {mli.description}
						{mli.partNumber ? ` (${mli.partNumber})` : null} @{' '}
						{currency.format(parseFloat(mli.unitPrice))} / {mli.unitType}
					</span>
					<span className="lineItemDetailText">{currency.format(parseFloat(mli.amount))}</span>
				</div>
			))}
			<Divider />
			<div className="sectionHeaderWrapper">
				<span className="sectionHeaderText">Travel</span>
				<span className="sectionHeaderText2">
					{currency.format(parseFloat(invoice.travelTotalBeforeTax) || 0)}
				</span>
			</div>
			<SimpleLineItemsDisplay
				invoice={invoice}
				lineItemFieldName="travelLineItems"
				currency={currency}
			/>
			<Divider />
			<div className="sectionHeaderWrapper">
				<span className="sectionHeaderText">Freight</span>
				<span className="sectionHeaderText2">
					{currency.format(parseFloat(invoice.freightTotalBeforeTax) || 0)}
				</span>
			</div>
			<SimpleLineItemsDisplay
				invoice={invoice}
				lineItemFieldName="freightLineItems"
				currency={currency}
			/>
			<Divider />
			<div className="sectionHeaderWrapper">
				<span className="sectionHeaderText">Miscellaneous</span>
				<span className="sectionHeaderText2">
					{currency.format(parseFloat(invoice.miscTotalBeforeTax) || 0)}
				</span>
			</div>
			<SimpleLineItemsDisplay
				invoice={invoice}
				lineItemFieldName="miscLineItems"
				currency={currency}
			/>
			<Divider />
			<div className="sectionHeaderWrapper">
				<span className="sectionHeaderText">Total Before Tax</span>
				<span className="sectionHeaderText2">{currency.format(invoice.invoiceTotalBeforeTax)}</span>
			</div>
			<Divider />
			<div className="sectionHeaderWrapper">
				<span className="sectionHeaderText">Tax</span>
				<span className="sectionHeaderText2">{currency.format(invoice.invoiceTax)}</span>
			</div>
			{nullSafeGetOrElse('taxLineItems', invoice, []).map((lli, idx) => (
				<div
					key={`taxLineItems-${idx}`}
					className="sectionHeaderWrapper2"
					style={{
						marginBottom:
							idx === nullSafeGetOrElse('taxLineItems', invoice, []).length - 1 ? 16 : 8,
					}}
				>
					<span className="lineItemDetailText">{lli.taxType}</span>
					<span className="lineItemDetailText">{currency.format(parseFloat(lli.amount))}</span>
				</div>
			))}
			<Divider />
			<div className="sectionHeaderWrapper">
				<span className="sectionHeaderText" style={{ fontWeight: 600 }}>
					Total After Tax
				</span>
				<span className="sectionHeaderText2" style={{ fontWeight: 600 }}>
					{currency.format(invoice.invoiceTotalAfterTax)}
				</span>
			</div>
		</>
	);
}
